import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { MANAGE_SEATS_TITLE, ManageSeatsDialog } from "@components/table/members/assign-seats/manage-seats-dialog";
import { PlusIcon, Tooltip } from "@flat-ui";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { useState } from "react";
/**
 * Button that lets the user pick seats of the workspace subscription to give a member, in a dialog.
 *
 * It is only shown while the row is hovered, since a members table that offered the action on every
 * row would draw the attention away from the seats the members do hold.
 *
 * The dialog stays mounted when the button is no longer offered, since saving it can change the
 * seats the button depends on while the dialog still has to go on, see ManageSeatsDialog.
 */
export function ManageSeatsButton(t0) {
  const $ = _c(9);
  const {
    member,
    isShown
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== isShown) {
    t1 = isShown && <Tooltip component="div" title={MANAGE_SEATS_TITLE} sx={{
      visibility: "hidden"
    }} data-testid="MANAGE_SEATS_BUTTON" className={SHOW_ON_HOVER_CLASS}><SphereIconButton buttonSize="24px" iconSize="22px" component={PlusIcon} onClick={() => setIsDialogOpen(true)} /></Tooltip>;
    $[0] = isShown;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDialogOpen(false);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isDialogOpen || $[4] !== member) {
    t3 = <ManageSeatsDialog member={member} isOpen={isDialogOpen} onClose={t2} />;
    $[3] = isDialogOpen;
    $[4] = member;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}